import { useSpring } from "@react-spring/core";
import { useMeasure, usePrevious } from "react-use";

export function useTransitionHeight<T extends HTMLElement>(
  springProps: Parameters<typeof useSpring>[0] = {}
) {
  const [bind, { height: viewHeight }] = useMeasure<T>();
  const previous = usePrevious(viewHeight);
  const style = useSpring({
    ...springProps,
    from: { height: previous },
    to: { height: viewHeight },
  });
  return [style, bind] as const;
}
